import { Flag } from '@/icons'

export function ViolationsHeader() {
  return (
    <div style={{ width: 16, height: 16 }}>
      <Flag size={20} />
    </div>
  )
}
